package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.PreMadeCharacter
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.PreMadeCharacterRepository

class GetPreMadeCharacterByIdUseCase(
    private val preMadeCharacterRepository: PreMadeCharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(id: String): Result<PreMadeCharacter?> {
        return preMadeCharacterRepository.getPreMadeCharacterById(id).map { preMade ->
            if (preMade?.imageUrl != null) {
                val signedUrlResult = imageStorageRepository.getSignedUrl(preMade.imageUrl)
                if (signedUrlResult.isSuccess) {
                    preMade.copy(signedImageUrl = signedUrlResult.getOrThrow())
                } else {
                    preMade
                }
            } else {
                preMade
            }
        }
    }
}
